import React from 'react'
import './yourcareer.css';
import { Container } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';


const YourCareer = ({setBlank, data }) => {
    
         const { eyebrow, heading, description, cta, theme } = data;

         const themeVars = {
            "--bg-from": theme.bgFrom,
            "--bg-to": theme.bgTo,
            "--text-color": theme.textColor,
            "--divider-from": theme.dividerFrom,
            "--divider-to": theme.dividerTo,
            "--button-from": theme.buttonFrom,
            "--button-to": theme.buttonTo,
            "--button-text": theme.buttonText,
        };
            
        // const scrollToTop = () => {
        //     setBlank(true);
        //     setTimeout(() => {
        //     window.scrollTo(0, 0);
        //     }, 100);
        //     setTimeout(() => {
        //     setBlank(false);            
        //     }, 600);
        // }
        
    return (
    <section className="career-banner" id="jobopening" style={themeVars}>
        <Container>
      <div className='career-banner_wrapper'>
      <div className="career-banner__content">
        <p className="career-banner__eyebrow">{eyebrow}</p>
        <h1 className="career-banner__heading" dangerouslySetInnerHTML={{ __html: heading }}></h1>
        {/* <div className="career-banner__divider" /> */}
        <p className="career-banner__description">{description}</p>
        {/* <a className="career-banner__cta" href={cta.href}>
          {cta.label}
        </a> */}
       
      </div>
       <NavLink to={cta.href} target="_blank" className="career-banner__cta" >{cta.label}</NavLink>
      </div>
      </Container>
    </section>
  );
}

export default YourCareer